// import cadreBbList from '../components/cadreBb/cadreBbList.vue'
// import addCadreBb from '../components/cadreBb/addCadreBb.vue'
// import cadreBbList from '../components/cadreBb/nodeCadreBb.vue'
// import cadreBbList from '../components/cadreBb/viewCadreBb.vue'

export default [
    { 
        path: 'cadreBb/cadreBbList',
        component: resolve => require(['@/components/cadreBb/cadreBbList'],resolve),
        name:'CadreBbList',
        meta:{
            id:'948',
            node:'cadreBb',
            url:'cadreBbList',
        }
    },
    { 
        path: 'cadreBb/addCadreBb',
        component: resolve => require(['@/components/cadreBb/addCadreBb'],resolve),
        name:'AddCadreBb',
        meta:{
            // id:'948',
            node:'cadreBb',
            url:'addCadreBb',
        }
    },
    { 
        path: 'cadreBb/nodeCadreBb',
        component: resolve => require(['@/components/cadreBb/nodeCadreBb'],resolve),
        name:'NodeCadreBb',
        meta:{
            // id:'948',
            node:'cadreBb',
            url:'nodeCadreBb',
        }
    },
    { 
        path: 'cadreBb/viewCadreBb',
        component: resolve => require(['@/components/cadreBb/viewCadreBb'],resolve),
        name:'ViewCadreBb',
        meta:{
            // id:'948',
            node:'cadreBb',
            url:'viewCadreBb',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/cadreBb.js